import BaseResource from './BaseResource';

export interface CompanyData {
  id: string;
  name: string;
  tokenCount: number;
  purchasedTokenCount: number;
}

class CompanyResource extends BaseResource<CompanyData> {
  static get storeName(): string {
    return 'CompanyResource';
  }

  static get endpoint(): string {
    return `/api/companies`;
  }

  static toObject(raw: any): CompanyResource {
    return new CompanyResource(raw as CompanyData);
  }

  static updateCredits(companyId: string, tokenCount: number, purchasedTokenCount: number) {
    return this.http.post(
      `${this.endpoint}/${companyId}/tokens`,
      {},
      {
        tokenCount,
        purchasedTokenCount,
      }
    );
  }
}

export default CompanyResource;
